<template>
	<div class="app-container">
		<el-button type="primary" size="small" @click="goback" >返回</el-button>

		<el-tabs type="border-card" v-model="tabName" style="margin-top: 20px;" >
			<!-- 聊天记录 -->
			<el-tab-pane label="聊天记录" name="chatRecord">
				<chat-record-view :type="0"/>
			</el-tab-pane>

			<!-- 答疑列表 -->
			<el-tab-pane label="答疑列表" name="question">
				<chat-record-view :type="2" />
			</el-tab-pane>

			<!-- 公告 -->
			<el-tab-pane label="公告" name="announcement">
				<chat-record-view :type="3" />
			</el-tab-pane>

			<!-- 用户信息 -->
			<el-tab-pane label="用户信息" name="userInfo">
				<memberView :forbiddenStatus="0"/>
			</el-tab-pane>

			<!-- 禁言列表 -->
			<el-tab-pane label="禁言列表" name="forbidden">
				<memberView :forbiddenStatus="1"/>
			</el-tab-pane>

      <!--学分卡 -->
      <el-tab-pane label="学分卡" name="creditCard">
        <live-credit-card-info/>
      </el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import chatRecordView from "@/views/systemManagement/liveMgt/liveList/chatRecordView"
	import memberView from "@/views/systemManagement/liveMgt/liveList/member/index"
  import LiveCreditCardInfo from "@/views/systemManagement/liveMgt/liveList/liveCreditCardInfo";
	export default {
		data() {
			return {
				tabName:""
			}
		},
		components: {
      LiveCreditCardInfo,
			chatRecordView,
			memberView,
		},
		created() {
			if (this.$route.query.liveID) {
				this.tabName = this.$route.query.tabName
			}
		},
		methods: {
			goback() {
				this.$router.go(-1);
			}
		},
	}
</script>

<style>
</style>
